import { getField, updateField } from "vuex-map-fields";
import { VuexModule, Module, Action } from "vuex-module-decorators";
import AuthenticateService from "@/views/authenticate/authenticate.service";
import { 
  LoginModel,
  LoginDto
 } from "@/views/authenticate/authenticate.types";
 import router from '@/router';

@Module({ namespaced: true })
class Authenticate extends VuexModule {
  user: LoginModel = new LoginModel();

  private _initialState!: Record<string, any>;

  constructor(module: any) {
    super(module);
    this._initialState = { ...this };
  }

  @Action({ rawError: true })
  async login(loginDto: LoginDto) {
    try {
      this.context.commit("Base/updateField", {
        path: "errorMessage",
        value: null
      }, { root: true });
      const user = await AuthenticateService.login(
        loginDto
      ) as LoginModel;
      this.context.commit("updateField", {
        path: "user",
        value: user
      });
    } catch (e: any) {
      const errorMessage = e.response.data.message;
      this.context.commit("Base/updateField", {
        path: "errorMessage",
        value: errorMessage
      }, { root: true });
    }
  }

  @Action({ rawError: true })
  async logout() {
    this.context.commit("updateField", {
      path: "user",
      value: new LoginDto()
    });
    router.push({ name: 'LoginComponent' });
  }

  @Action({ rawError: true })
  resetState() {
    for (const key of Object.keys(this._initialState)) {
      this.context.commit("updateField", {
        path: key,
        value: this._initialState[key]
      });
    }
  }
}

Authenticate.getters = { getField };
Authenticate.mutations = { updateField };

export default Authenticate;